export const splitTextByWord = (text: string, word: string) => {
  const parts = [];
  let startIndex = 0;
  let index;
  while (
    (index = text.toLowerCase().indexOf(word.toLowerCase(), startIndex)) !== -1
  ) {
    if (index > startIndex) {
      parts.push(text.substring(startIndex, index));
    }
    parts.push(text.substring(index, index + word.length));
    startIndex = index + word.length;
  }
  if (startIndex < text.length) {
    parts.push(text.substring(startIndex));
  }
  return parts;
};
